import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { IError } from '@unfoldrtech/portal-mic'
import {
  EReportColumnHeader,
  EParamChannelTypeGlobal,
  EReportingTimeWindow,
  IReportingCategoriesTableResponse,
} from '@unfoldrtech/portal-mic/dist/src/models/core'

import { generateCorrelationId, getTimezone } from '../utils/helpers'
import {
  TDACategoriesReportTableFilters,
  TPPRetailerId,
  TSPCategoriesReportTableFilters,
} from '../models/types'
import { coreAPIV3 } from '../services/coreAPIV3'

export default function useGetRetailerReportingCategoriesTableV3({
  retailerId,
  advertiserId,
  campaignId,
  adGroupId,
  channelType,
  sortBy,
  timeWindow,
  startDate,
  endDate,
  sortOrder,
  tzZone,
  pageLimit,
  pageOffset,
  filterBy,
  filterOperation,
  filterValue,
  name,
  status,
  enabled = true,
  suspense = true,
}: {
  enabled?: boolean
  suspense?: boolean
} & (TSPCategoriesReportTableFilters | TDACategoriesReportTableFilters) &
  TPPRetailerId): UseQueryResult<
  AxiosResponse<IReportingCategoriesTableResponse>,
  AxiosError<IError>
> {
  const queryKeyName = `getRetailerReportingCategoriesTable_${channelType}_${retailerId}_${advertiserId}`

  return useQuery(
    [queryKeyName, { start: startDate, end: endDate, channelType }],
    () => {
      return coreAPIV3.retailerReporting().getRetailerCategoriesReportTable(
        retailerId,
        generateCorrelationId(),
        advertiserId,
        campaignId,
        adGroupId,
        channelType as EParamChannelTypeGlobal,
        sortBy as EReportColumnHeader,
        sortOrder,
        timeWindow as EReportingTimeWindow,
        startDate,
        endDate,
        tzZone || getTimezone(),
        pageLimit,
        pageOffset,
        filterBy,
        filterOperation,
        filterValue,
        name,
        // @ts-expect-error: fix in PORT-2535
        status
      )
    },
    { suspense, enabled }
  )
}
